import React from 'react';
import Shared from 'screens/shared';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { objectToArray } from 'utils';
import { NAT_GATEWAY } from 'constant';
import createFormProps from './create';

export default ({
  items = [], ips = [], dcId, id: gatewayId,
}) => {
  const onSubmit = async (props) => {
    const { id, targetPortRange, ...properties } = props;

    if ([NAT_GATEWAY.PROTOCOL.TCP, NAT_GATEWAY.PROTOCOL.UDP].includes(properties?.protocol)) {
      properties.targetPortRange = targetPortRange;
    }

    if (id) {
      actions.natGateway.updateRule({
        dcId, id: gatewayId, properties, ruleId: id,
      });
    } else {
      actions.natGateway.createRule({ dcId, id: gatewayId, properties });
    }
  };

  const deleteHandler = (e) => {
    actions.natGateway.deleteRule({ dcId, id: gatewayId, ruleId: e.id });
  };

  return (
    <Shared.widgets.Section
      sectionTitle="NAT Gateway Rules"
      itemIcon="angle-double-right"
      className="-m-t-24"
      items={items}
      setItemTitle={(e) => e?.properties?.name}
      setItemDetails={(e) => `Protocol: ${e?.properties?.protocol}`}
      setDetailsModelTable={(e) => objectToArray(e?.properties || {})}
      isDeletePassword
      isItemDetailsModel
      itemOnDelete={deleteHandler}
      createForm={{ ...createFormProps, onSubmit, changeFields: [{ name: 'publicIp', props: { options: ips } }] }}
      createActionType={ACTIONS_TYPES.NAT_GATEWAY.CREATE_RULE}
      itemOnEdit={onSubmit}
      setItemEditProps={({ id, properties }) => ({ id, ...properties })}
    />
  );
};
